import {Injectable} from "@angular/core";
import {isNonRequiredTextOfMaxLength, isRequiredTextOfMaxLength} from "../../validations";
import {DoctorFindings} from "../analysis";
import {
  FindingsValidator,
  simpleValidationResult,
  ValidatedFindings,
  ValidationResult,
} from "../findings-validator";
import {EcgAnalysisComponent} from "./ecg-analysis.component";
import {MAX_CHARACTERS_IN_TEXT} from "../../utils";

@Injectable()
export class EcgFindingsValidator extends FindingsValidator<EcgAnalysisComponent> {
  validateFinishAnalysis(validatedFindings: EcgValidatedFindings): EcgFindingsValidationResult {
    return {
      patientStatusComments: simpleValidationResult(isRequiredTextOfMaxLength(MAX_CHARACTERS_IN_TEXT, validatedFindings.ecgFindings.patientStatusComments)),
      findings: simpleValidationResult(isRequiredTextOfMaxLength(MAX_CHARACTERS_IN_TEXT, validatedFindings.ecgFindings.findings)),
      conclusion: simpleValidationResult(isRequiredTextOfMaxLength(MAX_CHARACTERS_IN_TEXT, validatedFindings.ecgFindings.conclusion)),
      diagnosis: simpleValidationResult(isDiagnosisValid(validatedFindings)),
      symptomsComment: validatedFindings.measurementType === "SYMPTOM_HOLTER"
        ? simpleValidationResult(isRequiredTextOfMaxLength(MAX_CHARACTERS_IN_TEXT, validatedFindings.ecgFindings.symptomsComment))
        : simpleValidationResult(undefined)
    };
  }

  validateSaveAnalysis(validatedFindings: EcgValidatedFindings): EcgFindingsValidationResult {
    return {
      patientStatusComments: simpleValidationResult(isNonRequiredTextOfMaxLength(MAX_CHARACTERS_IN_TEXT, validatedFindings.ecgFindings.patientStatusComments)),
      findings: simpleValidationResult(isNonRequiredTextOfMaxLength(MAX_CHARACTERS_IN_TEXT, validatedFindings.ecgFindings.findings)),
      conclusion: simpleValidationResult(isNonRequiredTextOfMaxLength(MAX_CHARACTERS_IN_TEXT, validatedFindings.ecgFindings.conclusion)),
      diagnosis: simpleValidationResult(isNonRequiredTextOfMaxLength(MAX_CHARACTERS_IN_TEXT, validatedFindings.ecgFindings.diagnosis)),
      symptomsComment: simpleValidationResult(isNonRequiredTextOfMaxLength(MAX_CHARACTERS_IN_TEXT, validatedFindings.ecgFindings.symptomsComment))
    };
  }
}

export interface EcgValidatedFindings extends ValidatedFindings {
  ecgFindings: DoctorFindings;
}

function isDiagnosisValid(validatedEcgFindings: EcgValidatedFindings): boolean {
  if (validatedEcgFindings.measurementType !== "HOLTER_ECG") {
    return isNonRequiredTextOfMaxLength(MAX_CHARACTERS_IN_TEXT, validatedEcgFindings.ecgFindings.diagnosis);
  }

  return isRequiredTextOfMaxLength(MAX_CHARACTERS_IN_TEXT, validatedEcgFindings.ecgFindings.diagnosis);
}

export interface EcgFindingsValidationResult {
  conclusion: ValidationResult;
  findings: ValidationResult;
  patientStatusComments: ValidationResult;
  diagnosis: ValidationResult;
  symptomsComment: ValidationResult;
}

export function emptyEcgFindingsValidationResult(): EcgFindingsValidationResult {
  return {
    patientStatusComments: simpleValidationResult(undefined),
    findings: simpleValidationResult(undefined),
    conclusion: simpleValidationResult(undefined),
    diagnosis: simpleValidationResult(undefined),
    symptomsComment: simpleValidationResult(undefined),
  };
}
